import overview from './overview.vue';
import performance from './performance.vue';
import score from './score.vue';
import security from './security.vue';
import nodeSpeed from './nodeSpeed.vue';
import checkText from './checkText.vue';

export default {
	overview,
	performance,
	score,
	security,
	nodeSpeed,
	checkText,
};
